import api from 'api'
import { PositionId, WorkerRequirementId } from './types'

type Request = { positionId: PositionId; requirementId: WorkerRequirementId }
type Response = WorkerRequirementId

/** @deprecated This endpoint will be removed in the future in favour of assignRequirementToPosition.
 * The latter allows for the must_have value to be set and is being used by the new Position Details page.
 */
export async function addRequirementToPosition({
  positionId,
  requirementId,
}: Request) {
  const response = await api.put<Response>('/admin/positions/requirements', {
    position_id: positionId,
    requirement_id: requirementId,
  })

  return response.data
}
